// Shared admin-detection used by the report pages (Random Attendance Logs,
// Mood Report, Grooming Report). These pages send `employeeCode` only for
// non-admin callers; admins (super_admin, or a project admin for the currently
// selected project) need the full project roster, so the caller omits
// `employeeCode` to skip the backend's hierarchy filter entirely. This bypasses
// the fragile session/DB admin detection on the backend that has been observed
// to silently drop real super admins into hierarchy scoping.

// Only the admin-related fields are needed; keep the param structural so it
// stays decoupled from the authStore `User` type (which is not exported).
interface AdminUserFields {
  adminRole?: 'super_admin' | 'admin' | null;
  adminProjectIds?: number[];
}

export const isAdminForCurrentProject = (
  user: AdminUserFields | null | undefined,
  selectedProjectId: number | null | undefined,
): boolean =>
  user?.adminRole === 'super_admin' ||
  (user?.adminRole === 'admin' &&
    selectedProjectId !== null &&
    selectedProjectId !== undefined &&
    (user?.adminProjectIds || []).includes(selectedProjectId));
